import { Theme } from '@mui/material';

import { Maybe } from '@/types';

export const getCardStyles = ({
	backgroundColor: cardBackgroundColor,
	isDarkWrapperBackground,
	displayAsStepper,
	isSmallScreen,
}: {
	backgroundColor?: Maybe<string>;
	isDarkWrapperBackground: boolean;
	displayAsStepper: boolean;
	isSmallScreen: boolean;
}) => ({
	position: 'relative', // must be non-static because of the AspectRatioPaddingBox
	border: 'none',
	boxShadow: 'none',
	borderRadius: 0,
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	backgroundColor: cardBackgroundColor || 'transparent',
	flexBasis: 0,
	//covers the case when card's background is set but MultiCard's background is dark
	...(cardBackgroundColor !== 'transparent' && isDarkWrapperBackground
		? {
				'& .MuiTypography-root': {
					color: 'text.secondary',
				},
		  }
		: {}),
	...(displayAsStepper && isSmallScreen
		? {
				alignItems: 'flex-start',
		  }
		: {}),
});

export const getCardContentStyles = (
	isSmallScreen: boolean,
	displayAsStepper: boolean,
	cardsAlignment?: Maybe<string>,
	variant?: Maybe<string>
) => ({
	position: variant === 'Leadership' ? 'relative' : 'absolute',
	display: 'flex',
	flexDirection: 'column',
	gap: '1rem',
	...(cardsAlignment === 'center'
		? { padding: variant === 'TeamTag2' ? '1.25rem 1.25rem 1.75rem 1.25rem' : '0' }
		: { padding: '1.25rem 0 1.75rem 0' }),
	justifyContent: 'center',
	width: '100%',
	height: '100%',
	marginTop: variant === 'Leadership' ? '20px' : null,
	alignItems: displayAsStepper && isSmallScreen ? 'flex-start' : cardsAlignment || 'flex-start',
	zIndex: 1,
	...(displayAsStepper && isSmallScreen
		? {
				paddingLeft: 0,
		  }
		: {}),
});

export const getCardActionStyles = ({
	isSmallScreen,
	cardActionAlignment,
	displayAsStepper,
}: {
	isSmallScreen: boolean;
	cardActionAlignment?: Maybe<string>;
	displayAsStepper: boolean;
}) => ({
	paddingX: isSmallScreen ? '0.5rem' : 0,
	paddingTop: '0',
	marginTop: 'auto',
	paddingBottom: '1.75rem',
	justifyContent: displayAsStepper && isSmallScreen ? 'flex-start' : cardActionAlignment || 'flex-start',
});

export const pdfLinkStyles = {
	zIndex: 10,
	textDecoration: 'none',
};

export const getAvatarStyles = (theme: Theme, hasImageOrIcon: boolean) => ({
	width: { xs: '8.75rem', md: '10rem' },
	height: { xs: '8.75rem', md: '10rem' },
	background: hasImageOrIcon ? theme.palette.backgrounds?.light : theme.palette.neutrals?.dark,
	'.MuiAvatar-fallback': {
		display: 'none',
	},
});

export const getStepperCardBoxStyles = (isSmallScreen: boolean) => ({
	display: 'flex',
	justifyContent: isSmallScreen ? 'flex-start' : 'center',
	alignItems: 'center',
	width: '100%',
});

export const getCardMediaStyles = (useMediaRoundedCorners: boolean) => ({
	borderRadius: useMediaRoundedCorners ? '1rem' : 0,
	width: '100%', // Makes the image fill the card's width
	objectFit: 'cover', // Ensures the image covers the area, cropping if necessary
	position: 'relative', // Position behind the overlay content
	top: 0,
	left: 0,
	zIndex: 0, // Ensure image is at the bottom layer
});

export const cardDescriptonStyles = () => ({
	textAlign: 'center',
	'& img': {
		marginBottom: '1.5rem',
		width: '170px',
	},
	'& p': {
		textAlign: 'center',
		width: '70%',
		margin: 'auto',
		justifySelf: 'center',
	},
});
